declare global {
  interface Window {
    tailwind: {
      config?: any;
    };
  }
}

const configScriptContent = `
    tailwind.config = {
      theme: {
        extend: {
          borderRadius: {
            DEFAULT: '0.625rem'
          },
          colors: {
            background: 'oklch(0.87 0 0)',
            foreground: 'oklch(0.145 0 0)',
            card: {
              DEFAULT: 'oklch(1 0 0)',
              foreground: 'oklch(0.145 0 0)'
            },
            popover: {
              DEFAULT: 'oklch(1 0 0)',
              foreground: 'oklch(0.145 0 0)'
            },
            primary: 'oklch(0.551 0.027 264.364)',
            secondary: 'oklch(0.872 0.01 258.338)',
            muted: {
              DEFAULT: 'oklch(0.97 0 0)',
              foreground: 'oklch(0.556 0 0)'
            },
            accent: {
              DEFAULT: 'oklch(0.97 0 0)',
              foreground: 'oklch(0.205 0 0)'
            },
            destructive: 'oklch(0.577 0.245 27.325)',
            border: 'oklch(0.922 0 0)',
            input: 'oklch(0.922 0 0)',
            ring: 'oklch(0.708 0 0)',
            chart: {
              1: 'oklch(0.646 0.222 41.116)',
              2: 'oklch(0.6 0.118 184.704)',
              3: 'oklch(0.398 0.07 227.392)',
              4: 'oklch(0.828 0.189 84.429)',
              5: 'oklch(0.769 0.188 70.08)'
            },
            sidebar: {
              DEFAULT: 'oklch(0.985 0 0)',
              foreground: 'oklch(0.145 0 0)',
              primary: 'oklch(0.205 0 0)',
              'primary-foreground': 'oklch(0.985 0 0)',
              accent: 'oklch(0.97 0 0)',
              'accent-foreground': 'oklch(0.205 0 0)',
              border: 'oklch(0.922 0 0)',
              ring: 'oklch(0.708 0 0)'
            }
          }
        }
      },
      safelist: ['mx-auto', 'max-w-screen-xl', 'px-4', 'py-8', 'bg-background', 'text-foreground', 'font-sans', 'antialiased', 'min-h-screen', 'flex', 'flex-col', 'items-center', 'justify-center']
    }`;

const createTailwindScript = () => {
  return new Promise((resolve, reject) => {
    const tailwindCSS = document.createElement("script");
    tailwindCSS.id = "tailwind-css";
    tailwindCSS.src = "https://cdn.tailwindcss.com/3.4.16";
    tailwindCSS.onload = () => resolve(tailwindCSS);
    tailwindCSS.onerror = () =>
      reject(new Error("Failed to load Tailwind CSS"));
    document.head.appendChild(tailwindCSS);
  });
};

const createBootstrapCSS = () => {
  return new Promise((resolve, reject) => {
    const bootstrapCSS = document.createElement("link");
    bootstrapCSS.id = "bootstrap-css";
    bootstrapCSS.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css";
    bootstrapCSS.rel = "stylesheet";
    bootstrapCSS.integrity =
      "sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC";
    bootstrapCSS.crossOrigin = "anonymous";
    bootstrapCSS.onload = () => resolve(bootstrapCSS);
    bootstrapCSS.onerror = () =>
      reject(new Error("Failed to load Bootstrap CSS"));
    document.head.appendChild(bootstrapCSS);
  });
};

const createBootstrapJS = () => {
  return new Promise((resolve, reject) => {
    const bootstrapJS = document.createElement("script");
    bootstrapJS.id = "bootstrap-js";
    bootstrapJS.src =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/js/bootstrap.bundle.min.js";
    bootstrapJS.integrity =
      "sha384-MrcW6ZMFYlzcLA8Nl+NtUVF0sA7MsXsP1UyJoMp4YLEuNSfAP+JcXn/tWtIaxVXM";
    bootstrapJS.crossOrigin = "anonymous";
    bootstrapJS.onload = () => resolve(bootstrapJS);
    bootstrapJS.onerror = () =>
      reject(new Error("Failed to load Bootstrap JS"));
    document.head.appendChild(bootstrapJS);
  });
};

export const injectExternalCss = async ({
  isLegacy,
}: {
  isLegacy: boolean;
}) => {
  try {
    if (isLegacy) {
      await Promise.all([
        createBootstrapCSS(),
        createBootstrapJS(),
        createTailwindScript(),
      ]);
    } else {
      await createTailwindScript();
      const script = document.createElement("script");
      script.textContent = configScriptContent;
      document.head.appendChild(script);
    }
  } catch (error) {
    console.error("Failed to inject Bootstrap", error);
  }
};
